export const getOptionsForTagsInput = (strings: string[]): string[] => {
  return [...new Set(strings)];
};
